import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import axiosInstance from "../../../helpers/axios";
import CircularProgress from "@mui/material/CircularProgress";
export default function EditVlDetails({
  openEditDetails,
  setOpenEditDetails,
  applicationId,
}) {
  const user = null;
  const [loading, setLoading] = useState(false);
  const [formValues, setFormValues] = useState({
    brand: "",
    model: "",
    manufaturedDate: "",
    downPayment: "",
    chasisNo: "",
    engineNo: "",
  });
  useEffect(() => {
    getVerticalExtrasDetails();
  }, [openEditDetails]);
  const handleClose = () => {
    setOpenEditDetails(false);
  };

  const getVerticalExtrasDetails = async () => {
    try {
      const res = await axiosInstance(
        `/summary/vertical-extras?applicationId=${applicationId}`
      );
      const extraFields = res?.data?.data?.extraFields || {};
      setFormValues({
        brand: extraFields?.vBrand,
        model: extraFields?.vModel,
        manufaturedDate: extraFields?.vManufaturedDate,
        downPayment: extraFields?.vDownPayment,
        chasisNo: extraFields?.chasisNo,
        engineNo: extraFields?.engineNo,
      });
    } catch (e) {
      console.err("Failed to get details", e);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    const formData = new FormData(event.currentTarget);
    const { chasisNo, engineNo } = Object.fromEntries(formData.entries());
    try {
      await axiosInstance.post(
        "/summary/update-vertical-extras",
        {
          applicationId,
          extraFields: {
            chasisNo,
            engineNo,
            vBrand: formValues?.brand,
            vModel: formValues?.model,
            vManufaturedDate: formValues?.manufaturedDate,
            vDownPayment: formValues?.downPayment,
          },
        },
        {
          headers: {
          },
        }
      );
      alert("Details updated successfully.");
    } catch (error) {
      alert("Failed to update details", "Please contact support.");
    } finally {
      setOpenEditDetails(false);
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <Dialog open={openEditDetails} disableEscapeKeyDown>
      <DialogContent
        sx={{
          fontFamily: "Outfit",
          "& *": { fontFamily: "Outfit !important" },
        }}
      >
        <DialogContentText
          alogContentText
          sx={{ fontWeight: "bold", fontSize: "18px", color: "#000" }}
        >
          Edit Vehicle details
        </DialogContentText>
        <form
          onSubmit={handleSubmit}
          id="subscription-form"
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            flexWrap: "wrap",
          }}
        >
          <TextField
            margin="dense"
            id="brand"
            name="brand"
            label="Brand"
            variant="standard"
            value={formValues.brand}
            onChange={handleChange}
          />
          <TextField
            margin="dense"
            id="model"
            name="model"
            label="Model"
            variant="standard"
            value={formValues.model}
            onChange={handleChange}
          />
          <TextField
            margin="dense"
            id="manufaturedDate"
            name="manufaturedDate"
            label="Year of Manufature"
            type="number"
            variant="standard"
            value={formValues.manufaturedDate}
            onChange={handleChange}
          />
          <TextField
            margin="dense"
            id="downPayment"
            name="downPayment"
            type="number"
            label="Down Payment"
            variant="standard"
            value={formValues.downPayment}
            onChange={handleChange}
          />
          <TextField
            required
            margin="dense"
            id="chasisNo"
            name="chasisNo"
            label="Chasis No."
            variant="standard"
            value={formValues.chasisNo}
            onChange={handleChange}
          />
          <TextField
            required
            margin="dense"
            id="engineNo"
            name="engineNo"
            label="Engine No."
            variant="standard"
            value={formValues.engineNo}
            onChange={handleChange}
          />
        </form>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleClose}
          sx={{ textTransform: "none" }}
          disabled={loading}
        >
          Cancel
        </Button>
        <Button
          type="submit"
          form="subscription-form"
          sx={{ textTransform: "none" }}
          disabled={loading}
        >
          {loading ? <CircularProgress size={22} /> : "Update"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
